import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { PetitionQRCode } from 'src/app/shared/components/qrcode';

import { PetitionQRCodeDownloadLink } from './components/PetitionQRCodeDownloadLink';

type PetitionQRCodeDownloadProps = {
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onDownload?: () => Promise<void>;
};

/*
 Be aware that this component is a one-off copy of the original PetitionQRCodeDownload component located at:
 apps/front-end/src/app/shared/components/qrcode/PetitionQRCodeDownload.tsx

 This duplication is intentional because the original component is shared across multiple applications,
 and modifying it could lead to unintended consequences in those other applications.

 This copied version allows adjustments on the visual design and layout to fit the specific needs of the petition
 dashboard without affecting other applications.
 */
export function PetitionQRCodeDownload({
	slugOrId,
	displaySize,
	displayType,
	downloadSize,
	downloadType,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onDownload,
}: PetitionQRCodeDownloadProps): JSX.Element {
	return (
		<div className="flex flex-row gap-4">
			<div className="shrink-0">
				<PetitionQRCode slugOrId={slugOrId} size={displaySize} type={displayType} />
			</div>
			<div className="flex flex-col gap-2">
				<Text>{descriptionText}</Text>
				<PetitionQRCodeDownloadLink
					slugOrId={slugOrId}
					size={downloadSize}
					type={downloadType}
					onDownload={onDownload}
					filename={downloadFilename}
				>
					{downloadLinkText}
				</PetitionQRCodeDownloadLink>
			</div>
		</div>
	);
}
